import { apiClient } from "../lib/api";

// Public, unauthenticated careers portal endpoints - no cookies/JWT required.
export const careersApi = {
  listJobs: () => apiClient.get("/careers/jobs"),
  getJob: (id) => apiClient.get(`/careers/jobs/${id}`),
  apply: (payload) => apiClient.post("/careers/apply", payload),
  getApplicantStatus: (applicantId) => apiClient.get(`/careers/applicants/${applicantId}/status`),
  listInterviewSlots: (applicantId) => apiClient.get(`/careers/applicants/${applicantId}/interview-slots`),
  bookInterview: (applicantId, slotId) => apiClient.post(`/careers/applicants/${applicantId}/book-interview`, { slot_id: slotId }),
  cancelInterview: (applicantId, mode) => apiClient.post(`/careers/applicants/${applicantId}/cancel-interview`, { mode }),
  uploadResume: (applicantId, formData) => apiClient.post(`/careers/applicants/${applicantId}/resume`, formData, { headers: { "Content-Type": "multipart/form-data" } }),
  removeResume: (applicantId) => apiClient.delete(`/careers/applicants/${applicantId}/resume`),

  // Interview scheduling engine (2-hour protected block)
  getInterviewAvailability: (jobPostingId) => apiClient.get("/careers/interview-availability", { params: { job_posting_id: jobPostingId } }),
  createInterviewHold: (payload) => apiClient.post("/careers/interview-availability/hold", payload),
  releaseInterviewHold: (holdToken) => apiClient.post(`/careers/interview-availability/hold/${holdToken}/release`),
  rescheduleBooking: (applicantId, payload) => apiClient.post(`/careers/applicants/${applicantId}/interview-booking/reschedule`, payload),
  cancelBooking: (applicantId, reason) => apiClient.post(`/careers/applicants/${applicantId}/interview-booking/cancel`, { reason }),
};

